import { toPng } from 'html-to-image';
import { captureRequiredExportPng } from './export-image';

const getImages = async (ids) => {
  const images = Object();

  await Promise.all(
    ids.map(async (id) => {
      const node = document.getElementById(id);
      images[id] = await captureRequiredExportPng(node, toPng, {
        assetName: id,
      });
    })
  );

  return images;
};

export default getImages;
